import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ChevronRight } from 'lucide-react';
import { api } from '../../context/AuthContext';

export const PortalZustimmungen = ({ caseId }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/portal/akten/${caseId}/zustimmungen`).then((r) => setItems(r.data.items || [])).catch(() => {}); }, [caseId]);
  if (!items.length) return null;
  return (
    <section className="space-y-2" data-testid="portal-zustimmungen">
      <h2 className="text-base md:text-lg font-serif text-[#1B3A5C]">Zustimmungen</h2>
      {items.map((z) => (
        <Link key={z.id} to={`/portal/zustimmung/${z.id}`} data-testid={`portal-zustimmung-${z.id}`} className={`flex items-center gap-3 p-4 rounded-2xl border transition-colors ${z.status === 'offen' ? 'bg-[#fbf7f0] border-[#b8893d]/60 hover:border-[#b8893d]' : 'bg-white border-gray-200'}`}>
          <ShieldCheck className="w-5 h-5 text-[#b8893d]" />
          <span className="flex-1 text-sm text-[#1B3A5C]">{z.art_label}<span className="block text-xs text-gray-500">{z.status === 'offen' ? 'Ihre Entscheidung wird benötigt' : z.status}</span></span>
          <ChevronRight className="w-4 h-4 text-gray-400" />
        </Link>
      ))}
    </section>
  );
};
